module.exports = __webpack_public_path__ + "img/quit_icon.92bc9688.svg";